import type { ContactShell } from '../contact-types';

/**
 * How the brand stands with this contact, read from the rail's own
 * collaboration rows (built from the summary slice):
 * - `affiliate`: the contact holds an affiliation with the brand (the
 *   affiliation row only exists for an affiliate, active or not);
 * - `prospect`: no affiliation and no collaboration in flight;
 * - `null`: a collaboration is running without an affiliation, which is
 *   neither, so no relation badge is drawn.
 */
export type ContactRelation = 'affiliate' | 'prospect';

export const contactRelationOf = (
  collaborations: ContactShell['collaborations']
): ContactRelation | null => {
  if (collaborations.some((row) => row.view === 'affiliation')) return 'affiliate';
  if (collaborations.some((row) => row.implemented && row.active)) return null;
  return 'prospect';
};
